import { defineStore } from 'pinia'
import type { Ref } from 'vue'
import { computed, ref } from 'vue'
import * as PrepareApi from '@app/application/client_meetings/api/prepare'

import { SfLog } from '@app/adapters/logger'

export const useSuggestedTalkingPointsStore = defineStore(
  'suggestedTalkingPoints',
  () => {
    const suggestions: Ref<string[]> = ref([])
    const suggestionCount = computed(() => suggestions.value.length)
    const loadingSuggestions: Ref<boolean> = ref<boolean>(false)

    async function fetchSuggestions(): Promise<void> {
      loadingSuggestions.value = true
      try {
        const response = await PrepareApi.getAISuggestions()
        suggestions.value = response ? response : []
      } catch (e) {
        SfLog.error('Error fetching AI suggestions', {
          error: e,
        })
      }

      loadingSuggestions.value = false
    }

    function setSuggestions(newSuggestions: string[]): void {
      suggestions.value = newSuggestions
    }

    async function removeSuggestion(
      suggestion: string,
      remarkId: number
    ): Promise<void> {
      suggestions.value = suggestions.value.filter((s) => s !== suggestion)
      try {
        await PrepareApi.removeAISuggestion(suggestion, remarkId)
      } catch (e) {
        SfLog.error('Error removing AI suggestion', {
          error: e,
        })
      }
    }

    return {
      suggestions,
      suggestionCount,
      setSuggestions,
      loadingSuggestions,
      fetchSuggestions,
      removeSuggestion,
    }
  }
)
